module.exports = __webpack_public_path__ + "3f67db3a112eed0e4f84db5306ce6306.svg";